import {useUnit} from 'effector-react';
import {useEffect} from 'react';
import {$usersStore, fetchUserDetailRequested, toggleUserFollowRequested} from '../store';
import {UserDetailResponse} from '../model/types';

export const useUserDetailViewModel = (userId: string | undefined) => {
  const [usersState, fetchUserDetail, toggleUserFollow] = useUnit([
    $usersStore,
    fetchUserDetailRequested,
    toggleUserFollowRequested,
  ]);

  const fetchUserById = (id: string) => {
    fetchUserDetail(id);
  };

  useEffect(() => {
    if (userId) {
      fetchUserDetail(userId);
    }
  }, [userId, fetchUserDetail]);

  const getUserDetail = (): UserDetailResponse | null => {
    return usersState.selectedUser;
  };

  const handleToggleUserFollow = (userId: string, isFollowing: boolean) => {
    toggleUserFollow({userId, isFollowing});
  };

  return {
    user: usersState.selectedUser,
    loading: usersState.loading,
    error: usersState.error,
    fetchUserById,
    getUserDetail,
    toggleUserFollow: handleToggleUserFollow,
  };
};